import {USD_DISPLAY_DECIMALS} from '@/constants/config'
import {useCurrencySymbol} from '@/lib/locale/country'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'
import roundToNDecimal from '@/utils/numbers/roundToNDecimals'

import style from './ProductCard.module.scss'

export default memo<{
  orgPrice: number | string
  price: number | string
}>(function ProductOriginalPrice({orgPrice, price}) {
  const currencySymbol = useCurrencySymbol()

  if (typeof orgPrice === 'string' || typeof price === 'string') {
    return null
  }

  const roundedOrgPrice = roundToNDecimal(orgPrice)
  const priceChangePercentage =
    price && orgPrice ? roundToNDecimal((1 - price / orgPrice) * 100, 0) : 0

  if (priceChangePercentage === 0) {
    return null
  }

  return (
    <div className={style.ProductOriginalPrice}>
      <VisuallyHidden>
        {`Reduced by over ${priceChangePercentage}% compared to the original price of ${
          currencySymbol
        }${roundedOrgPrice}`}
      </VisuallyHidden>
      <span className={style.CurrencySign} aria-hidden>
        {currencySymbol}
      </span>
      <span className={style.OriginalPrice} aria-hidden>
        {roundedOrgPrice.toFixed(USD_DISPLAY_DECIMALS)}
      </span>
      <span className={style.PercentageChange} aria-hidden>
        -{priceChangePercentage}%
      </span>
    </div>
  )
})
